import axios from 'axios'
import create from 'zustand'
import shallow from 'zustand/shallow'
import { ID_LENGTH_TO_REGION } from '../constants/regions'

const FLAGGED_ENDPOINT =
  process.env.REACT_APP_DATA_ENDPOINT + 'flagged/'

const fixId = id => {
  if (
    Object.keys(ID_LENGTH_TO_REGION).indexOf(
      id.length.toString()
    ) > -1
  )
    return '' + id
  return '0' + id
}

export const loadFlaggedData = type => {
  return axios.get(FLAGGED_ENDPOINT + type + '.json?version=2')
}

/**
 * loads flagged schools
 */
export const loadFlaggedLocations = () =>
  Promise.all(
    ['gifted', 'lep', 'spedidea', 'years'].map(async type => {
      return loadFlaggedData(type)
        .then(result => {
          return type === 'years'
            ? result.data
            : result.data.map(fixId)
        })
        .catch(error => {
          console.error('unable to load flag', type, error)
          window.SEDA.trackProblem(
            'error loading flagged locations'
          )
        })
    })
  )

const useFlagStore = create(set => ({
  loaded: false,
  gifted: [],
  lep: [],
  spedidea: [],
  years: [],
  set
}))

export default function useLocationFlags() {
  const {
    loaded,
    gifted,
    lep,
    spedidea,
    years,
    set
  } = useFlagStore(state => state, shallow)
  if (!loaded) {
    loadFlaggedLocations().then(res => {
      set({
        loaded: true,
        gifted: res[0],
        lep: res[1],
        spedidea: res[2],
        years: res[3],
      })
    })
  }
  return [
    gifted,
    lep,
    spedidea,
    years,
  ]
}
